import { useSelector } from "react-redux";
import { Card } from "@app/design-system/components";
import { UserIcon } from "@app/design-system/icons";
import { CustomFieldsNavButton } from "@app/features/shared/CustomFieldsNavButton";
import { RootState } from "@app/store";
import { t } from "@app/utils/translation";
import { CustomerInfoRowProps } from "./CustomerInfoRow.types";
import styles from "./CustomerInfoRow.module.css";

/**
 * Order Details' Customer Information card — sits directly below the page
 * header (see OrderDetailsPage.tsx). The row itself is never clickable;
 * only the trailing badge + arrow (when the order has custom fields to show
 * on the not-yet-built Custom Fields Details page) is its own button, so
 * tapping the icon/name elsewhere in the card does nothing.
 */
export const CustomerInfoRow = ({ customerName, customFieldsCount, onClick }: CustomerInfoRowProps) => {
  const language = useSelector((state: RootState) => state.setting.language);
  const hasCustomFields = customFieldsCount > 0;

  return (
    <Card padded={false} grouped>
      <div className={styles.row}>
        <UserIcon size={32} className={styles.icon} />
        <div className={styles.body}>
          <div className={styles.label}>{t("Customer", language)}</div>
          <div className={styles.name}>{customerName}</div>
        </div>
        {hasCustomFields ? <CustomFieldsNavButton count={customFieldsCount} onClick={onClick} /> : null}
      </div>
    </Card>
  );
};
